/**
 * Identity for a source-location option in the internal-transfer form.
 *
 * A warehouse location can hold several lots of the same SKU, and
 * `GET /wms/inventory/stock-by-location` returns one row per (location, lot).
 * Keying the dropdown options on locationId alone makes those rows collide:
 * TreeSelect cannot tell them apart, so only the first is selectable and its
 * lot and quantity get applied no matter which row the user clicked.
 * Identify an option by location AND lot instead.
 */
export const SOURCE_KEY_SEPARATOR = '::';

export const makeSourceKey = (locationId: string, lotNumber: string): string =>
  `${locationId}${SOURCE_KEY_SEPARATOR}${lotNumber || ''}`;

export const parseSourceKey = (
  key: string
): { locationId: string; lotNumber: string } => {
  const idx = (key || '').indexOf(SOURCE_KEY_SEPARATOR);
  // No separator means a legacy value — a plain path stored on an existing
  // transfer before options carried the lot.
  if (idx === -1) return { locationId: key || '', lotNumber: '' };
  return {
    locationId: key.slice(0, idx),
    lotNumber: key.slice(idx + SOURCE_KEY_SEPARATOR.length),
  };
};
